export function createCookiesArray(cookies) {
  return cookies.split(";");
}

export function getCookiePreference(type) {
  let cookies = createCookiesArray(document.cookie);
  let isCookiesAccepted = false;
  if (cookies && cookies.length > 0) {
    if (type === "portal") {
      cookies.map(el => {
        if (el.includes("_portal_necessary_cookies_accepted")) {
          isCookiesAccepted = true;
          return;
        }
      });
    } else if (type === "pweb") {
      cookies.map(el => {
        if (el.includes("_pweb_necessary_cookies_accepted")) {
          isCookiesAccepted = true;
          return;
        }
      });
    }
  }
  return isCookiesAccepted;
}

export function setNecessaryCookies(type) {
  // Build the expiration date string:
  let expirationDate = new Date();
  let cookieString = "";
  expirationDate.setFullYear(expirationDate.getFullYear() + 1);
  if (type === "portal") {
    cookieString = "_portal_necessary_cookies_accepted=true; path=/; expires=" + expirationDate.toUTCString();
    document.cookie = cookieString;
  } else if (type === "pweb") {
    cookieString = "_pweb_necessary_cookies_accepted=true; path=/; expires=" + expirationDate.toUTCString();
    document.cookie = cookieString;
  }
}
